export const ERROR_MESSAGES = {
  400: "Invalid request",
  401: "Unauthorized access",
  403: "Access denied",
  404: "Data not found",
  500: "Internal server error",
};